import { getLang } from 'mailup-react-helpers'
import help from '../documentation/help.json'

export const openHelp = (pageId) => {
  let lang = getLang()
  lang = lang === 'it' || lang === 'es' ? lang : 'en'
  return help?.[pageId]?.[lang] ?? ''
}
